import { useCallback, useState } from 'react';
import api, { AddressData } from '../api';

interface UseCheckOwnerAddressAvailabilityResult {
  isLoading: boolean;
  error: string | null;
  isAvailable: boolean | null;
  checkAddress: (addressData: AddressData) => Promise<void>;
  resetAvailability: () => void;
}

export default function useCheckOwnerAddressAvailability(): UseCheckOwnerAddressAvailabilityResult {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [isAvailable, setIsAvailable] = useState<boolean | null>(null);

  const checkAddress = useCallback(async (addressData: AddressData) => {
    setIsLoading(true);
    setError(null);
    setIsAvailable(null);
    try {
      const result = await api.checkOwnerAddressAvailability(addressData);
      // Expecting API to return { available: boolean }
      setIsAvailable(Boolean(result?.available));
    } catch (err: unknown) {
      const errorMessage =
        err instanceof Error ? err.message : 'Failed to check address availability';
      setError(errorMessage);
      setIsAvailable(null);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const resetAvailability = useCallback(() => {
    setIsLoading(false);
    setError(null);
    setIsAvailable(null);
  }, []);

  return { isLoading, error, isAvailable, checkAddress, resetAvailability };
}
